import { GridSpg } from "@duosoftbg/nacid-components";
import React from "react";
import styled from "styled-components";

const Section = styled(GridSpg)`
  background: #fafafa;
  border-top: 1px solid #0054a4;
  border-bottom: 1px solid #0054a4;
  padding: 20px;
`;

const CategoryContent = ({ children }) => {
  return (
    <Section className={"serviceContainer"} container spacing={5}>
      {children}
    </Section>
  );
};

export default CategoryContent;
